var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.466,
    height: 22,
    viewBox: "0 0 21.466 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sort-amount-down-alt",
    d: "M22.051.917a.916.916,0,0,1-.917.917H9.216A.917.917,0,1,1,9.216,0H21.134A.916.916,0,0,1,22.051.917ZM18.384,4.584H9.216a.917.917,0,1,0,0,1.833h9.167a.917.917,0,1,0,0-1.833Zm-2.75,4.584H9.216a.917.917,0,0,0,0,1.833h6.417a.917.917,0,1,0,0-1.833Zm-2.75,4.584H9.216a.917.917,0,1,0,0,1.833h3.667a.917.917,0,1,0,0-1.833ZM7.114,17.687,5.549,19.252V.917a.917.917,0,1,0-1.833,0V19.252L2.15,17.686a.917.917,0,1,0-1.3,1.3l2.482,2.482a1.836,1.836,0,0,0,2.593,0L8.41,18.982a.917.917,0,1,0-1.3-1.3Z",
    transform: "translate(-0.585)",
    fill: "#1d2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c828179d99e39dd872fab7708db99c39.svg";
export { ForwardRef as ReactComponent };